"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UriSchemaPortList = (function () {
    function UriSchemaPortList() {
    }
    UriSchemaPortList.getPort = function (schema) {
        return this[schema.toLowerCase()];
    };
    UriSchemaPortList.isDefaultPort = function (schema, port) {
        return this.getPort(schema) === port;
    };
    UriSchemaPortList.http = 80;
    UriSchemaPortList.https = 80;
    UriSchemaPortList.relative = undefined;
    return UriSchemaPortList;
}());
exports.UriSchemaPortList = UriSchemaPortList;
